import React, {forwardRef} from 'react';
import {FormField, NumberFormat} from 'components';
import {over, pick, useField, useSuggestionPopup} from 'helpers';
import css from './edit.module.scss';

export function Edit({Suggestions, ...props}) {
  const [field, {error, touched}, {setValue}, isSubmitting] = useField(props);

  const [popup, input] = useSuggestionPopup(Suggestions, {
    ...props,
    value: field.value,
    setValue,
    className: 'adjacent'
  });

  return (
    <FormField invalid={error && touched} {...props} value={field.value} {...popup}>
      <Input
        type="text"
        {...field}
        {...pick(props, 'autoFocus', 'placeholder', 'type', 'onKeyDown', 'required')}
        {...input}
        onChange={over(field.onChange, input?.onChange)}
        autoComplete="off"
        className={css.edit}
        disabled={isSubmitting}
        setValue={setValue}
        value={field.value || ''}
      />
      { error && touched &&
        <span className={css.error}>{error}</span>
      }
    </FormField>
  );
}

const Input = forwardRef(({ type, onChange, setValue, ...props }, ref) => {
  if (type == 'number') {
    return (
      <NumberFormat
        {...props}
        onValueChange={({ value }) => setValue(value, props.name)}
        ref={ref}
        thousandSeparator
      />
    );
  }
  return (
    <input onChange={onChange} type={type} ref={ref} {...props} />
  );
});
